<template>
<div>
  <h2>Tłumaczenie</h2>
  <v-form ref="form">
    <v-select @change="changed()" :rules="nameRules" v-model="lang" label="Język" :items="langs"></v-select>
    <v-container>
      <div v-for="field in fields">
        <v-text-field :rules="nameRules"  v-model="model[field.id]" :label="field.name"></v-text-field>
        <v-container v-if="field.type == 'radio'">
          <v-text-field :value="getValueTranslation(value.key, field.id)" v-for="value in field.values" @change="setValueTranslation($event, value.key, field.id)" :rules="nameRules"   :label="value.value"></v-text-field>
        </v-container>
      </div>
    </v-container>
    <v-btn @click="submit()">Submit</v-btn>
  </v-form>
</div>
</template>

<script>
import langs from "@/plugins/langs";
export default {
  data() {
    return {
      langs: langs.getSupportedLangs(),
      schema: {},
      model: {},
      valuesModel: {},
      translations: [],
      schemaFields: [],
      lang: "",
      nameRules: [
        (v) => !!v || this.$t('team.create.error.no-name-msg')
      ]
    }
  },
  computed: {
    fields() {
      let fields = []
      this.schemaFields.forEach(field => {
        fields.push(field)
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    }
  },
  methods: {
    getValueTranslation(valueKey, fieldId){
      if(!this.valuesModel[fieldId]){
        return ""
      }
      return this.valuesModel[fieldId][valueKey]
    },
    setValueTranslation(inputValue, valueKey,fieldId){
      if(!this.valuesModel[fieldId]){
        this.valuesModel[fieldId] = {}
      }
      this.valuesModel[fieldId][valueKey] = inputValue
    },
    getValuesTranslation(fieldId){
      if(!this.valuesModel[fieldId]){
        return []
      }
      let res = []
      for (let keyObj in this.valuesModel[fieldId]){
        res.push({ 'key' : keyObj, 'translation' : this.valuesModel[fieldId][keyObj]})
      }
      return res
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }

      let postData = this.createPostData()
      this.$http.post(`schema/${this.schema.id}/translations`, postData).then(data => {
        this.translations.push(data.data)
        this.$store.commit('setSnack', {
          message: "Dodano tłumaczenie",
          color: 'success'
        })
      }).catch(() => {
        this.$store.commit('setSnack', {
          message: "Problem z dodaniem tłumaczenia",
          color: 'success'
        })
      })
    },
    createPostData() {
      return {
        'lang': this.lang,
        'translations': this.fieldsTranslation()
      }
    },
    fieldsTranslation() {
      let fieldsTranslation = []
      for (let fieldId in this.model) {
        fieldsTranslation.push({
          'id': fieldId,
          'translation': this.model[fieldId],
          'values' : this.getValuesTranslation(fieldId)
        })
      }
      return fieldsTranslation
    },
    changed() {
      this.model = {}
      this.valuesModel = {}
      let translations = this.translations.filter(v => v.lang == this.lang)
      translations.forEach(translation => {
        this.model[translation['id_field']] = translation['translation']

        if(translation.values && translation.values.length > 0) {
          translation.values.forEach(translationValue =>
              this.setValueTranslation(translationValue.translation, translationValue.key,translation['id_field'] ) )
        }
      })
    }
  },
  created() {
    let schema = this.$http.get('schema/' + this.$route.params.schemaId)
    let translations = this.$http.get('schema/' + this.$route.params.schemaId + '/translations')

    Promise.all([schema, translations]).then((data) => {
      this.schemaFields = data[0].data.fields
      this.schema = data[0].data
      this.translations = data[1].data
    }).catch(() => {
      this.$route.push({
        name: "not-found"
      })
    });
  }
}
</script>
